import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react'

class TableFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {value:this.props.value, popupIsOpen: false};
        this.onSearchClick = this.onSearchClick.bind(this)
        this.onDeleteClick = this.onDeleteClick.bind(this)
        this.onSearchKeyPress = this.onSearchKeyPress.bind(this)
        this.onInputChange = this.onInputChange.bind(this)
        this.onBlur = this.onBlur.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.state = {
            value: nextProps.value
        };
    }

    onInputChange(ev){
        if (ev.target.value !== undefined){
            this.setState({ value: ev.target.value });
            if (this.props.changeEventOnKeyPress){
                this.doSearch(ev.target.value)
            }
        }
    }

    onSearchClick() {
        this.doSearch(this.state.value)
        this.setState({popupIsOpen: false})
    }

    onBlur() {
        console.log("BLUR!");
    }

    onDeleteClick() {
        this.setState({value:''});
        this.doSearch('')
        this.setState({popupIsOpen: false})
    }

    onSearchKeyPress(ev) {

        if (ev.key === 'Enter')
        {
            this.doSearch(ev.target.value)
            this.setState({popupIsOpen: false})
        }
    }

    doSearch(keyword) {
        if (this.props.onChangeFilter !== undefined)
        {
            let retVal = {};
            retVal[this.props.valueName] = keyword;
            this.props.onChangeFilter(retVal);
        }
    }

    render() {
        return (<div className="ui form">
            <div className="fields">
                <div className="sixteen wide field">

                    <div className="ui action input" >
                        {
                            this.props.showPopup ?
                                <Popup
                                    trigger={<input type="text" placeholder={this.props.placeholder} ref="searchField" value={this.state.value} onChange={this.onInputChange}
                                                    onKeyPress={this.onSearchKeyPress}/>}
                                    on="focus"
                                    position={this.props.popupPosition}
                                    hideOnScroll
                                    flowing
                                    open={this.state.popupIsOpen}
                                >
                                    <Popup.Header>{this.props.popupHeader}</Popup.Header>
{/*
                                    <Popup.Content>
                                        <p>Inserisci le parole chiave da cercare, separate da <b>spazio</b> per metterle in OR nella query di ricerca, separate da <b>+</b> per metterle in AND.</p>
                                        <p><b>ES: </b><code>kw1 kw2</code> : trova tutti gli elementi che contengono <code>kw1</code> <b>oppure</b> <code>kw2</code></p>
                                        <p><b>ES: </b><code>kw1+kw2</code> : trova tutti gli elementi che contengono <code>kw1</code> <b>e</b> <code>kw2</code></p>

                                    </Popup.Content>
*/}
                                    <Popup.Content>
                                        <p>{this.props.placeholder}</p>
                                        <p>Inserisci le parole chiave da cercare, separate da <b>spazio</b>: saranno messe in <b>AND</b> nella query di ricerca.</p>
                                        <p><b>ES: </b><code>kw1 kw2</code> : trova tutti gli elementi che contengono <code>kw1</code> <b>e</b> <code>kw2</code></p>
                                        <p><b>ES: </b><code>kw1 kw2 kw3</code> : trova tutti gli elementi che contengono contemporaneamente <code>kw1</code> <b>e</b> <code>kw2</code><b>e</b> <code>kw3</code></p>

                                    </Popup.Content>
                                </Popup>
                                :
                                <input type="text" placeholder={this.props.placeholder} ref="searchField" value={this.state.value} onChange={this.onInputChange}
                                       onKeyPress={this.onSearchKeyPress} />
                        }

                        <button className="ui right icon button" onClick={this.onSearchClick}>
                            <i className="circular search link icon"></i>
                        </button>
                        <button className="ui right  icon button" onClick={this.onDeleteClick}>
                            <i className="circular cancel icon"></i>
                        </button>
                    </div>
                </div>
            </div>

        </div>)
    }
}

TableFilter.PropTypes = {
    value: PropTypes.string,
    valueName: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    popupHeader: PropTypes.string.isRequired,
    showPopup: PropTypes.bool.isRequired,
    changeEventOnKeyPress: PropTypes.bool.isRequired,
    popupPosition: PropTypes.string.isRequired,
    onChangeFilter: PropTypes.func
}

TableFilter.defaultProps = {
    value: '',
    valueName: 'keyword',
    showPopup: false,
    changeEventOnKeyPress: false,
    popupHeader: "Ricerca per keyword",
    popupPosition: "bottom left"
};

export default TableFilter;




/** WEBPACK FOOTER **
 ** ./src/components/TableFilter.jsx
 **/